export const uniqBy = <T>(array: T[], predicate: keyof T | Function) => {
  const callback =
    typeof predicate === "function" ? predicate : (o: T) => o[predicate];

  return [
    ...array
      .reduce((map, item) => {
        const key = item === null || item === undefined ? item : callback(item);

        map.has(key) || map.set(key, item);

        return map;
      }, new Map())
      .values()
  ];
};

export const mode = <T>(
  array: T[],
  comparator?: (a: T, b: T) => boolean
): T | null =>
  array
    .sort(
      (a, b) =>
        array.filter(v => (comparator ? comparator(v, a) : v === a)).length -
        array.filter(v => (comparator ? comparator(v, b) : v === b)).length
    )
    .pop() || null;
